import { Dictionary } from '@app/core/models';

export interface StatsAction {
  type: StatsActionType;
  options?: StatsOptions;
  graphType?: StatsGraphType;
}

export enum StatsActionType {
  GET_FIELD_VALUES = 'getFieldValues',
  GET_SERIES = 'getSeries',
  FORM_SUCCESS = 'formSuccess',
  FORM_RESET = 'formReset',
};

export enum StatsGraphType {
  SERIES = 'series',
  PIE = 'pie',
}

export interface StatsOptions {
  group: string;
  value: string;
  aggFunction: string;
  filter: Dictionary<string, string>;
  startDate: Date;
  endDate: Date;
}

export interface StatsIntervalsOptions extends StatsOptions {
  unit: string,
  amount: number
}
